<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
            :columns="['TIPO VISITAS', $lang.Common.DataTable.Actions]"
            :showNew="true"
            :showSearch="true"
            :showReload="true"
            :showTipFooter="false"
            v-on:New="onNew"
            v-on:Search="onShowSearch"
            v-on:Load="onLoad"
            v-on:Reload="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <template v-if="obj.visitName !== 'CRM'">
          <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.active ? 1 : 0" :value="obj.visitName ? obj.visitName.toUpperCase() : ''" />
          <td class="text-center">
            <div v-if="!obj.active">
              <b-dropdown variant="link" size="sm" no-caret>
                <template slot="button-content">
                  <i
                      class="fa fa-lock-open text-secundary icone-grid"
                      style="color: black;"
                      :title="$lang.GroupsConfig.UnlockGroupToolTip"
                  ></i>
                </template>
                <b-dropdown-header><strong>{{ $lang.GroupsConfig.ConfirmUnlockGroup }}</strong></b-dropdown-header>
                <b-dropdown-item
                    href="javascript:void(0);"
                    v-on:click="changeGroupStatus(obj, 'true')"
                >
                  {{ $lang.Common.Yes }}
                </b-dropdown-item>
                <b-dropdown-item
                    href="javascript:void(0);"
                >
                  {{ $lang.Common.No }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
            <div v-else>
              <b-dropdown variant="link" size="sm" no-caret>
                <template slot="button-content">
                  <i
                      class="fa fa-ban text-secundary icone-grid"
                      style="color: red;"
                      :title="$lang.GroupsConfig.BlockGroupToolTip"
                  ></i>
                </template>
                <b-dropdown-header>
                  <strong>{{ $lang.GroupsConfig.ConfirmBlockGroup }}</strong>
                </b-dropdown-header>
                <b-dropdown-item
                    href="javascript:void(0);"
                    v-on:click="changeGroupStatus(obj, 'false')"
                >
                  {{ $lang.Common.Yes }}
                </b-dropdown-item>
                <b-dropdown-item
                    href="javascript:void(0);"
                >
                  {{ $lang.Common.No }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </template>
      </tr>
    </Tables>
    <div class="row">
      <div class="col-12 pb-3 pl-4">
        <button type="button" class="btn btn-third btn-sm" v-on:click="$emit('New')" v-b-tooltip.hover :title="'Clique para cadastrar'"><i class="fas fa-user-plus"></i> <span class="d-md-down-none">&nbsp; Novo</span></button>
      </div>
    </div>
    <SidebarSearch @search="onSearch" />
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

import VisitTypeRepository from '@/shared/http/repositories/configurations/visittype.js'
import SidebarSearch from '@/views/private/configurations/eventtype/components/search/SidebarFUPTipoEvento.vue'

export default {
  name: 'VisitTypeList',
  mixins: [ActionsForm],
  data () {
    return {
      filters: null,
      data: null,
      form: null
    }
  },
  components: {
    SidebarSearch
  },
  methods: {
    onLoad () {
      this.onLoadAll()
    },
    onLoadAll () {
      loading.push()
      if (this.filters && this.filters.nome) {
        let optionFilters = ''

        if (this.filters.nome) {
          optionFilters += `nome=${this.filters.nome}&`
        }
        VisitTypeRepository.Search(optionFilters, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        VisitTypeRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onNew () {
      this.$emit('New')
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    onDelete (obj) {
      loading.push()
      VisitTypeRepository.Delete(obj.id)
        .then(this.onResult)
        .catch(this.onException)
    },
    changeGroupStatus (obj, status) {
      loading.push()
      VisitTypeRepository.ChangeStatus(obj.id)
        .then(() => {
          this.onLoadAll()
          loading.pop()
        })
        .catch(this.onException)
    },
    onSearch (filters) {
      this.filters = filters
      this.$refs.tableGrid.Clear()
      this.$nextTick(() => {
        this.onLoadAll()
      })
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/visitas/visit-type/components/list/visittypelist.vue